import { ApiDfmWithUsers } from '@/api/_legacy/generated-api'

import { Mutation } from '../../types'

export const mutateDfmName = (
  mutation: (c: Mutation<ApiDfmWithUsers>) => void,
  updatedValue: string
) => {
  mutation(c => (c.dfmName = updatedValue))
}
